(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emilija-cart-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emilija-cart-upsells')) {
    class EmilijaCartUpsells extends HTMLElement {
      connectedCallback() {
        this.pending = false;
        this.skippedId = null;
        try {
          this.groups = JSON.parse(this.dataset.emilijaGroups);
        } catch {
          this.groups = null;
        }
        this.onSkip = (event) => {
          const button = event.target.closest('[data-skip-upsell-product]');
          if (button && this.contains(button)) {
            this.skippedId = button.closest('[data-quick-add-holder]')?.getAttribute('data-quick-add-holder');
            this.scheduleSync();
          }
        };
        this.observer = new MutationObserver(() => this.scheduleSync());
        this.observer.observe(this, { childList: true, subtree: true });
        this.addEventListener('click', this.onSkip, true);
        this.scheduleSync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onSkip, true);
      }

      scheduleSync() {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          if (this.isConnected) this.sync();
        });
      }

      sync() {
        const slots = Array.from(this.querySelectorAll('[data-emilija-offer-id]'));
        const present = new Map();
        for (const slot of slots) {
          if (slot.querySelector('[data-quick-add-holder]')) {
            present.set(slot.dataset.emilijaOfferId, slot);
          }
        }
        const groups = Array.isArray(this.groups) ? this.groups : Array.from(present.keys(), id => [id]);
        const visibleIds = new Set();
        for (const group of groups) {
          const nextId = group.find(id => present.has(id));
          if (nextId) visibleIds.add(nextId);
        }
        for (const slot of slots) {
          slot.hidden = !visibleIds.has(slot.dataset.emilijaOfferId);
        }
        this.hidden = visibleIds.size === 0;

        if (this.skippedId) {
          const skippedId = this.skippedId;
          this.skippedId = null;
          if (!present.has(skippedId)) {
            const related = groups.filter(group => group.includes(skippedId));
            const nextId = related.flat().find(id => visibleIds.has(id)) || visibleIds.values().next().value;
            const cart = this.closest('cart-drawer, [data-cart-page]');
            const target = present.get(nextId)?.querySelector('[data-quick-add-btn]')
              || cart?.querySelector('[data-cart-checkout-button]');
            target?.focus({ preventScroll: true });
          }
        }
      }
    }

    customElements.define('emilija-cart-upsells', EmilijaCartUpsells);
  }
  } catch(e) { console.error(e); }
})();

})();
